import script from "./ForgetPasswordMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForgetPasswordMain.vue?vue&type=script&lang=ts&setup=true"

import "./ForgetPasswordMain.vue?vue&type=style&index=0&id=81365f2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81365f2e"]])

export default __exports__